(function () {
    'use strict';
  
    function initMtReviewSlider() {
      const sections = document.querySelectorAll('.mt-review-slider');
      if (!sections.length) return;
  
      sections.forEach(function (section) {
        new MtReviewSlider(section);
      });
    }
  
    class MtReviewSlider {
      constructor(section) {
        this.section = section;
        this.track = section.querySelector('.mt-review-slider__track');
        this.slides = Array.from(section.querySelectorAll('.mt-review-slider__slide'));
        this.prevBtn = section.querySelector('.mt-review-slider__arrow--prev');
        this.nextBtn = section.querySelector('.mt-review-slider__arrow--next');
  
        if (!this.track || !this.slides.length) return;
  
        this.index = 0;
        this.autoplayDelay = parseInt(section.getAttribute('data-autoplay'), 10) || 0;
        this.transitionDuration = parseInt(section.getAttribute('data-transition'), 10) || 400;
        this.timer = null;
        this.isAnimating = false;
  
        this.setup();
      }
  
      setup() {
        this.section.style.setProperty('--mt-transition-duration', this.transitionDuration + 'ms');
  
        this.slides.forEach(function (slide, idx) {
          slide.classList.toggle('mt-review-slider__slide--active', idx === 0);
          // slide.style.zIndex = String(10 + idx);
        });
  
        if (this.prevBtn) {
          this.prevBtn.addEventListener('click', () => this.goPrev());
        }
        if (this.nextBtn) {
          this.nextBtn.addEventListener('click', () => this.goNext());
        }
  
        // Only enable autoplay and navigation if there's more than one slide
        if (this.slides.length > 1) {
          this.section.addEventListener('mouseenter', () => this.stopAutoplay());
          this.section.addEventListener('mouseleave', () => this.startAutoplay());
          this.startAutoplay();
        }
      }
  
      goTo(index) {
        if (this.isAnimating || index === this.index) return;
  
        const total = this.slides.length;
        let target = index;
        if (target < 0) target = total - 1;
        if (target >= total) target = 0;
  
        const currentSlide = this.slides[this.index];
        const nextSlide = this.slides[target];
        if (!currentSlide || !nextSlide) return;
  
        this.isAnimating = true;
  
        currentSlide.classList.remove('mt-review-slider__slide--active');
        nextSlide.classList.add('mt-review-slider__slide--active');
  
        this.index = target;
  
        window.setTimeout(() => {
          this.isAnimating = false;
        }, this.transitionDuration + 50);
      }
  
      goNext() {
        this.goTo(this.index + 1);
        this.resetAutoplay();
      }
  
      goPrev() {
        this.goTo(this.index - 1);
        this.resetAutoplay();
      }
  
      startAutoplay() {
        if (!this.autoplayDelay || this.autoplayDelay <= 0) return;
        this.stopAutoplay();
        this.timer = window.setInterval(() => {
          this.goNext();
        }, this.autoplayDelay * 1000);
      }
  
      stopAutoplay() {
        if (this.timer) {
          window.clearInterval(this.timer);
          this.timer = null;
        }
      }
  
      resetAutoplay() {
        this.stopAutoplay();
        this.startAutoplay();
      }
    }
  
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initMtReviewSlider);
    } else {
      initMtReviewSlider();
    }
  
    if (typeof document.addEventListener !== 'undefined') {
      document.addEventListener('shopify:section:load', function (event) {
        if (!event.detail || !event.detail.sectionId) return;
        const section = document.querySelector('.section-' + event.detail.sectionId + ' .mt-review-slider');
        if (section) {
          new MtReviewSlider(section);
        }
      });
    }
  })();
  
  
  